export default __webpack_public_path__ + "static/media/human.1e06a013.png";